<template>
  <header class="text-white px-6 md:px-12 py-4 z-10 relative">
    <div class="max-w-7xl mx-auto flex justify-between items-center">
      <a href="/">
        <img src="/logo-integrator/logo.png" alt="Integrator Host" class="h-[55px] w-auto" />
      </a>

      <!-- Menu desktop com submenu -->
      <nav class="hidden md:flex items-center space-x-10">
        <a href="/" class="hover:text-cormenutop">Home</a>

        <!-- Submenu de Serviços com clique e clique fora -->
        <div class="relative">
          <div
            @click.stop="toggleDesktopSubmenu"
            class="hover:text-cormenutop flex items-center gap-1 no-underline relative z-20 cursor-pointer px-2 py-1"
          >
            <span>Serviços</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          <!-- Submenu -->
          <div
            v-if="desktopSubmenuOpen"
            ref="submenuRef"
            class="absolute left-0 mt-1 bg-white text-[#1a237e] shadow-lg rounded-xl py-3 w-80 px-4 transition-all duration-200 z-50"
          >
            <a
              v-for="(item, index) in servicos"
              :key="index"
              :href="item.link"
              class="flex items-center gap-3 py-2 px-2 rounded-lg hover:bg-gray-100 transition text-[#1a237e] no-underline"
            >
              <div class="w-8 h-8 flex items-center justify-center">
                <img
                  v-if="item.icon.endsWith('.png')"
                  :src="item.icon"
                  alt=""
                  class="w-12 h-8 rounded-full bg-pink-100"
                />
                <div
                  v-else
                  class="w-8 h-8 bg-pink-500 text-white rounded-full flex items-center justify-center text-sm"
                >
                  {{ item.icon }}
                </div>
              </div>
              <span class="text-sm font-medium">{{ item.label }}</span>
            </a>
          </div>
        </div>

        <a href="/atendimento" class="hover:text-cormenutop">Atendimento</a>

        <!-- Botão Portal do Cliente -->
        <a
          href="https://painel.integrator.host/"
          target="_blank"
          rel="noopener noreferrer"
          class="mt-1 bg-gray-700 hover:bg-gray-600 text-white text-sm px-4 py-3 rounded-full transition self-start"
        >
          Portal do Cliente
        </a>
      </nav>

      <!-- Botão hamburguer no mobile -->
      <button @click="toggleMenu" class="md:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>

    <!-- Menu mobile dropdown -->
    <div v-if="isOpen" class="md:hidden mt-4 flex flex-col space-y-2 px-4">
      <a href="/" class="hover:text-cormenutop">Home</a>

      <!-- Submenu mobile -->
      <div>
        <button @click="toggleSubmenu" class="w-full text-left hover:text-cormenutop">Serviços</button>
        <div v-if="submenuOpen" class="ml-4 mt-1 flex flex-col space-y-1">
          <a
            v-for="(item, index) in servicos"
            :key="index"
            :href="item.link"
            class="hover:text-cormenutop no-underline"
          >
            {{ item.label }}
          </a>
        </div>
      </div>

      <a href="/atendimento" class="hover:text-cormenutop">Atendimento</a>

      <!-- Botão Portal do Cliente no mobile -->
      <a
        href="https://painel.integrator.host/"
        target="_blank"
        rel="noopener noreferrer"
        class="mt-1 bg-gray-700 hover:bg-gray-600 text-white text-sm px-4 py-3 rounded-full transition self-start"
      >
        Portal do Cliente
      </a>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const isOpen = ref(false)
const submenuOpen = ref(false)
const desktopSubmenuOpen = ref(false)
const submenuRef = ref(null)

const toggleMenu = () => {
  isOpen.value = !isOpen.value
  if (!isOpen.value) submenuOpen.value = false
}

const toggleSubmenu = () => {
  submenuOpen.value = !submenuOpen.value
}

const toggleDesktopSubmenu = () => {
  desktopSubmenuOpen.value = !desktopSubmenuOpen.value
}

const handleClickOutside = (event) => {
  if (submenuRef.value && !submenuRef.value.contains(event.target)) {
    desktopSubmenuOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

const servicos = [
  { label: 'Hospedagem PHP', icon: '/icones-menu/dropdown-php.png', link: 'plano-hospedagem-php' },
  { label: 'Hospedagem Revenda PHP', icon: '/icones-menu/dropdown-revenda.png', link: 'plano-hospedagem-revenda' },
  { label: 'Hospedagem Java', icon: '/icones-menu/dropdown-java.png', link: 'plano-hospedagem-java' },
  { label: 'Hospedagem Spring Boot', icon: '/icones-menu/dropdown-spring.png', link: 'plano-hospedagem-spring' },
  { label: 'Hospedagem Node.js', icon: '/icones-menu/dropdown-node.png', link: 'plano-hospedagem-node' },
  { label: 'VPS Linux', icon: '/icones-menu/dropdown-vpssempainel.png', link: 'plano-vps-linux' },
  { label: 'VPS com cPanel/Whm', icon: '/icones-menu/dropdown-vpscompainel.png', link: 'plano-vps-cpanel' },
  { label: 'VPS com ICP', icon: '/icones-menu/dropdown-vpscompainel.png', link: 'plano-vps-icp' },
  { label: 'Servidor Dedicado', icon: '/icones-menu/dropdown-server.png', link: 'plano-dedicado' },
  { label: 'Promoções', icon: '/icones-menu/dropdown-promocional.png', link: 'plano-promocao' }
]
</script>
